import React from 'react'
import { Button } from '@shared/components/button'
import { scrollToPartnerForm } from '@shared/components/forms/partner'
import { Section } from '@shared/components/section'
import cx from 'classnames'

import styles from './style.module.scss'

const items: string[] = [
	'Комфортную ставку без сюрпризов на сделке',
	'Возможность быстро получить деньги на любые цели',
	'Упрощенный формат проведения сделки без посещения МФЦ.',
]

export const FooterBlock = () => (
	<Section className={styles.footer}>
		<h2 className={styles.title}>Ваш клиент получит</h2>
		<ol className={cx(styles.list)}>
			{items.map((item, idx) => (
				<li key={idx} className={cx(styles.item, 'on-style-type')}>
					{item}
				</li>
			))}
		</ol>
		<Button onClick={scrollToPartnerForm} className={styles.btn} variant='filled'>
			Стать партнёром
		</Button>
	</Section>
)
